"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingPaymentMethodType = void 0;
var BillingPaymentMethodType;
(function (BillingPaymentMethodType) {
    BillingPaymentMethodType["CARD"] = "CARD";
    BillingPaymentMethodType["SEPA_DEBIT"] = "SEPA_DEBIT";
})(BillingPaymentMethodType || (exports.BillingPaymentMethodType = BillingPaymentMethodType = {}));
